import React, { FC, useState, useEffect } from 'react';
import { apiService } from 'utils/api';
import { toast } from 'react-toastify';
import SurgeApplyNowSection from '../surge-tabs/surge-apply-now';
import { InstantTabPayload, SurgeTabProps } from '../surge-tabs/types';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import useDashboardContext from 'contexts/dashboard.context';

const orderUrl = process.env.REACT_APP_ORDER_STATS_API_KEY;

const GeneralSurgeApplyNow: FC<SurgeTabProps> = ({ confirm, setLoading, onClose, activeSurge }) => {
  const [value, setValue] = useState<InstantTabPayload>({
    logistics_surge: '',
    logistics_surge_type: ''
  });
  const { activeCokitchen } = useDashboardContext();
  const setGeneralSurge = async () => {
    try {
      const url = 'logistics/surge/general/instant';
      const res = await apiService.post(url, {
        data: { ...value, cokitchen_id: activeCokitchen.id },
        baseUrl: orderUrl
      });
      const data = res?.data?.general_surge_history;
      return data;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (confirm === 'Apply Now') {
      (async () => {
        try {
          setLoading(true);
          await setGeneralSurge();
          toast(<ToastMessage type='success' message='Updated successfully' />);
          onClose();
        } catch (error) {
          toast(<ToastMessage type='error' message='There was an error updating surge' />);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [confirm]);

  return <SurgeApplyNowSection value={value} setValue={setValue} activeSurge={activeSurge} />;
};

export default GeneralSurgeApplyNow;
